module.exports = __webpack_public_path__ + "static/media/Basal_6070.2746b4ea.jpg";